import _ from 'underscore';
import { FeedbackType } from '../../botTypes';

export const getCurrentFeedback = (activity: any): FeedbackType => {
  const { reactionsAdded } = activity;
  const firstAdded: FeedbackType = _.get(reactionsAdded, ['0', 'type']);

  return firstAdded || 'None';
};
